import { CategoryDocument } from './category.models';
import { PolicyDocument } from './policy.model';

export class Residence {
  uuid!: string | null;

  name!: string;

  cmsId: string | null | undefined;

  cmsUid!: string;

  searchableName!: string;

  policyDocuments: PolicyDocument[] | null | undefined;

  categoryTypes: CategoryDocument[] | null | undefined;

  slug!: string;

  isSearchable!: boolean;

  override_uk_number!: string | null;

  override_ire_number!: string | null;

  show_ireland_line!: boolean | null;

  showPartner!: boolean | null;

  covered!: boolean;

  total_sum_insured!: string | null;

  tl_sum_insured!: string | null;

  university_building_cover!: boolean;

  wellbeing!: boolean;

  category_uid!: string;

  partner_link_uid!: string;

  sites_covered_url!: string;
}
